import common from '@/services/common'
import uuid from 'uuid'

export default {
  async getConfigBaseUrls(configName) {
    return common.execute('get', `/api/configuration/v1/${configName}/urls`)
  },
  async updateConfig(configName, config) {
    return common.execute('post', `/api/configuration/v1/${configName}/beta`, config)
  },
  async publishToProduction(configName) {
    return common.execute('post', `/api/configuration/v1/${configName}/betatoprod`)
  },
  async hold(configName) {
    return common.execute('put', `/api/configuration/v1/${configName}/hold`)
  },
  async release(configName) {
    return common.execute('delete', `/api/configuration/v1/${configName}/hold`)
  },
  async schedulePromotion(configName, promoteTime) {
    const body = {
      promoteTime: promoteTime,
    }
    return await common.execute('post', `/api/configuration/v1/${configName}/schedule`, body)
  },
  async cancelScheduledPromotion(configName, scheduleTaskId) {
    const body = {
      taskName: scheduleTaskId,
    }
    return await common.execute('delete', `/api/configuration/v1/${configName}/schedule`, body)
  },
  async getConfig(url, options = {}) {
      if (options.cacheBust) {
        url =`${url}?cachebust=${uuid.v4()}`
      }
      return common.executeExternal('get', url, null, null, (resp) => resp)
    },
}
